import Component from "@glimmer/component"
import type { CardStack, CardStackSummary } from "@shared/models/card-stack"
import type { Course, Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"

interface Signature {
  Args: {
    models: {
      cardStack: CardStack
      planbook: Planbook
      rotationCalendar: RotationCalendar
      course: Course
      lessonIsFulfilled: boolean
      unitInfo: Unit
      units: Array<CardStackSummary>
    }
    editCourseTitleAndOrder: Function
    /** Display the unit as readonly regardless of permissions. Only respected by the unified editor. */
    showUnitReadonly?: boolean
  }
}

export default class UnitComponent extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::Unit": typeof UnitComponent
  }
}
